import React from 'react';

interface PackageStatsProps {
  numTitan: number;
  numPioneer: number;
  titanPrice: number;
  pioneerPrice: number;
}

export const PackageStats: React.FC<PackageStatsProps> = ({ numTitan, numPioneer, titanPrice, pioneerPrice }) => {
  const formatCurrency = (val: number) => 
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h4 className="text-lg font-bold text-gray-800 mb-4 border-b pb-2">Thống kê Gói Đầu Tư</h4>
      <div className="space-y-6">
        {/* Titan */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="font-semibold text-gray-700 flex items-center">
              <span className="w-3 h-3 rounded-full bg-blue-600 mr-2"></span> Titan
            </span>
            <span className="text-gray-600 font-medium">{numTitan} gói</span>
          </div>
          <div className="flex justify-between text-sm text-gray-500 mb-1">
            <span>Trọng số: 6 phần/gói</span>
            <span>Giá trị: {formatCurrency(titanPrice)}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-blue-600 h-2 rounded-full w-[70%]"></div>
          </div>
        </div>

        {/* Pioneer */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="font-semibold text-gray-700 flex items-center">
              <span className="w-3 h-3 rounded-full bg-teal-500 mr-2"></span> Pioneer
            </span>
            <span className="text-gray-600 font-medium">{numPioneer} gói</span>
          </div>
          <div className="flex justify-between text-sm text-gray-500 mb-1">
            <span>Trọng số: 1 phần/gói</span>
            <span>Giá trị: {formatCurrency(pioneerPrice)}</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-teal-500 h-2 rounded-full w-[30%]"></div>
          </div>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-100 mt-4">
          <h5 className="text-sm font-semibold text-gray-700 mb-2">Công thức phân bổ phần</h5>
          <code className="text-xs bg-gray-800 text-green-400 p-2 rounded block break-all">
            Tổng phần = (Số Titan × 6) + (Số Pioneer × 1)
          </code>
        </div>
      </div>
    </div>
  );
};